module.exports = __webpack_public_path__ + "img/hr-arithmetic-combinator-shadow.99c94589.png";